import { useContext, useEffect, useState, useCallback } from 'react'

import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListSubheader,
  TextField,
  Typography,
  alpha,
  styled,
} from '@mui/material'
import MoveDownIcon from '@mui/icons-material/MoveDown';
import { NavLink as RouterLink, useNavigate } from 'react-router-dom'
import BusinessIcon from '@mui/icons-material/Business';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PostAddIcon from '@mui/icons-material/PostAdd';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import RestoreIcon from '@mui/icons-material/Restore'
import { SidebarContext } from '../../../../contexts/SidebarContext'
import { useCommandPaletteActionsSetter } from '../../../../contexts/CommandPaletteContext'
import LogoutTwoTone from '@mui/icons-material/LogoutTwoTone'
import LoginTwoTone from '@mui/icons-material/LoginTwoTone'
import PeopleIcon from '@mui/icons-material/People'
import CategoryTwoToneIcon from '@mui/icons-material/CategoryTwoTone'
import ViewListIcon from '@mui/icons-material/ViewList'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import StoreIcon from '@mui/icons-material/Store'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import SettingsIcon from '@mui/icons-material/Settings'
import ContactSupportIcon from '@mui/icons-material/ContactSupport'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import LogoutIcon from '@mui/icons-material/Logout'
import ReceiptIcon from '@mui/icons-material/Receipt'
import SummarizeIcon from '@mui/icons-material/Summarize'
import AssessmentIcon from '@mui/icons-material/Assessment'
import InventoryIcon from '@mui/icons-material/Inventory'
import PaymentIcon from '@mui/icons-material/Payment'
import DescriptionIcon from '@mui/icons-material/Description'
import ListAltIcon from '@mui/icons-material/ListAlt'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import AddBoxIcon from '@mui/icons-material/AddBox'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone'
import ClearTwoToneIcon from '@mui/icons-material/ClearTwoTone'
import hotkeys from 'hotkeys-js';
import { removeToken } from '../../../../utils'
import { logout , Bill, Customer, Vendor } from '../../../../services'
import { useAppDispatch, useAppSelector } from '../../../../hooks'
import { trackTutorialEvent } from '../../../../utils/analytics'
import { EVENTS } from '../../../../constants/googleEvents'
import ApplicationLinks from '../../../../ApplicationLinks'
import AnalyticsManager from '../../../../analytics/AnalyticsManager'
import SubmitItem from '../../../../../src/content/applications/CurrentAccounts/SubmitItem'
import { SiteDto } from '../../../../../src/components/SitesAutoComplete/Services'
import { CreateMonthlyBill } from '../../../../../src/content/applications/MonthlyBills/CreateMonthlyBill'
import { AddEditPaymentItem } from '../../../../../src/content/applications/slips/AddEditPayment'
import OtherCharges from '../../../../../src/content/applications/CurrentAccounts/OtherCharges'
import { AddAccountItem } from '../../../../../src/content/applications/CurrentAccounts/AddNewAccountItem'
import IssueMoreItem from '../../../../../src/content/applications/CurrentAccounts/IssueMoreItem'
import AddCustomer from '../../../../../src/content/applications/Customers/AddCustomer'
import AddStockDialog from '../../../../../src/content/applications/StockTransactions/AddStockDialog'
import AddVendor from '../../../../../src/content/applications/Vendors/AddVendor'
import CreateSaleInvoiceDialog from '../../../../../src/content/applications/SaleInvoices/CreateSaleInvoiceDialog'

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(0.5, 0.5, 0.5, 1)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(0.5)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.colors.alpha.black[100]};
      padding: ${theme.spacing(0, 0)};
      line-height: 1.4;
    }
`
)

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 0px 0;
        font-weight: 300;

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(1.5)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.dark};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: 300;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          font-weight: 400;

          color: ${theme.colors.alpha.black[80]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(0.6, 0.5, 0.6, 0.5)};

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};
            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.black[80]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(0.75)};
            min-width: auto;
          }
          
          .MuiButton-endIcon {
            color: ${theme.colors.alpha.black[80]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }
          
          &.active,
          &:hover {
            background-color: ${alpha(theme.colors.alpha.black[100], 0.06)};
            color: ${theme.colors.alpha.black[100]};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.black[100]};
            }
          }
          &.Mui-focusVisible {
            background-color: ${alpha(theme.colors.alpha.black[100], 0.06)};
            color: ${theme.colors.alpha.black[100]};
            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.black[100]};
            }
            border: 1px dotted;
          }
        }

        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(5)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 1.5)};

              .MuiBadge-root {
                right: ${theme.spacing(1.5)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.black[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
                  'transform',
                  'opacity',
                ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }
              &.active,
              &:hover {
                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
)


function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext)
  const { data } = useAppSelector((state) => state.userData)
  const navigate = useNavigate()
  // const itemHeight = 34
  const dispatchAction = useAppDispatch()
  const SCROLL_KEY = 'sidebar-scroll'
  const { setActions } = useCommandPaletteActionsSetter()

  // Save scroll position before navigation
  const saveScrollBeforeNav = () => {
    const scrollbarView = document.querySelector('.rcs-view') as HTMLElement
    if (scrollbarView) {
      sessionStorage.setItem(SCROLL_KEY, scrollbarView.scrollTop.toString())
    }
  }

  const [logoutLoading, setLogoutLoading] = useState<boolean>(false)
  const handleLogout = useCallback(async (): Promise<void> => {
    closeSidebar()
    setLogoutLoading(true)
    try {
      await logout()
    } catch {
      setLogoutLoading(false)
      return // Only clear local data when logout API succeeds
    }
    // Clear analytics user properties on logout
    AnalyticsManager.shared.clearUserProperties()
    removeToken()
    dispatchAction({ type: 'CLEAR_ALL_STORE_DATA' })
    setLogoutLoading(false)
    navigate('/login')
  }, [closeSidebar, dispatchAction, navigate])
  const [showAddCustomer, setShowAddCustomer] = useState<boolean>(false)
  const [newAccount, setNewAccount] = useState<Bill | null>(null)
  const [openNewSite, setOpenNewSite] = useState<boolean>(false)
  const [createOutwardChallan, setCreateOutwardChallan] = useState<boolean>(false)
  const [siteTransfer, setSiteTransfer] = useState<boolean>(false)
  const [createInwardChallan, setCreateInwardChallan] = useState<boolean>(false)
  const [showReceiveExcess, setShowReceiveExcess] = useState<boolean>(false)
  const [showAddPayment, setShowAddPayment] = useState<boolean>(false)
  const [showReceiveLost, setReceiveLost] = useState<boolean>(false)
  const [showOtherCharge, setShowOtherCharge] = useState<boolean>(false)
  const [showCreateMonthlyBill, setShowCreateMonthlyBill] = useState<boolean>(false)
  const [showCreateSaleInvoice, setShowCreateSaleInvoice] = useState<boolean>(false)
  const [showAddStock, setShowAddStock] = useState<boolean>(false)
  const [showAddVendorForStock, setShowAddVendorForStock] = useState<boolean>(false)
  const [newVendorForAddStock, setNewVendorForAddStock] = useState<Vendor | null>(null)
  const [newCustomer, setNewCustomer] = useState<Customer>(null)
  const [searchQuery, setSearchQuery] = useState<string>('')

  
  useEffect(() => {
    hotkeys('alt+f2', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/dashboard/current-account")
    });  
  
    hotkeys('alt+f3', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/management/customers")
    });
  
    hotkeys('alt+f4', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/more/all-challans/OUT")
    });
  
    hotkeys('alt+f5', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/more/all-challans/IN")
    });
  
    hotkeys('alt+f10', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/reports/all-bills")
    });
  
    
    hotkeys('alt+d', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/slips/by-date/DATE")
    });
    hotkeys('alt+p', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/management/profile/details")
    });
  
    hotkeys('alt+s', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/management/profile/settings")
    });
    hotkeys('alt+r', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/charts/billing-chart")
    });
  
    hotkeys('alt+k', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/stock/item-category")
    });
  
    hotkeys('alt+b', function(event, handler){
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/charts/sites-stock-summary")
    });
  
    hotkeys('f2', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      setOpenNewSite(true)
    });
    hotkeys('f3', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      setShowAddCustomer(true)
    });
    hotkeys('f4', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      setCreateOutwardChallan(true)
    });
    hotkeys('f5', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      setCreateInwardChallan(true)
    });
    hotkeys('f6', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      setReceiveLost(true)
    });
  
    hotkeys('f8', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      setShowAddPayment(true)
    });
    
    hotkeys('f9', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      setShowOtherCharge(true)
    });
    hotkeys('f10', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      setShowCreateMonthlyBill(true)
    });
    hotkeys('f11', function (event, handler) {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()
      setAllFalse()
      navigate("/bills/recent-bills")
    });
    // Cleanup hotkeys on unmount
    return () => {
      hotkeys.unbind('alt+f2');
      hotkeys.unbind('alt+f3');
      hotkeys.unbind('alt+f4');
      hotkeys.unbind('alt+f5');
      hotkeys.unbind('alt+f10');
      hotkeys.unbind('alt+d');
      hotkeys.unbind('alt+p');
      hotkeys.unbind('alt+s');
      hotkeys.unbind('alt+r');
      hotkeys.unbind('alt+k');
      hotkeys.unbind('alt+b');
      hotkeys.unbind('f2');
      hotkeys.unbind('f3');
      hotkeys.unbind('f4');
      hotkeys.unbind('f5');
      hotkeys.unbind('f6');
      hotkeys.unbind('f8');
      hotkeys.unbind('f9');
      hotkeys.unbind('f10');
      hotkeys.unbind('f11');
    };
  }, [])

  function setAllFalse() {
    setShowAddCustomer(false)
    setNewAccount(null)
    setOpenNewSite(false)
    setCreateOutwardChallan(false)
    setSiteTransfer(false)
    setCreateInwardChallan(false)
    setShowAddPayment(false)
    setReceiveLost(false)
    setShowOtherCharge(false)
    setShowCreateMonthlyBill(false)
    setShowCreateSaleInvoice(false)
    setShowAddStock(false)
    setShowAddVendorForStock(false)
    setNewVendorForAddStock(null)
    setNewCustomer(null)
  }

  // Filter function to check if menu item should be shown
  const shouldShowMenuItem = (text: string): boolean => {
    if (!searchQuery.trim()) {
      return true
    }
    return text.toLowerCase().includes(searchQuery.toLowerCase())
  }

  // Helper function to check if section has any visible items
  const hasVisibleItems = (items: string[]): boolean => {
    if (!searchQuery.trim()) {
      return true
    }
    return items.some(item => shouldShowMenuItem(item))
  }

  // Update command palette actions whenever state changes
  useEffect(() => {
    const commandPaletteActions = {
      openNewSite: () => {
        closeSidebar()
        setOpenNewSite(true)
      },
      showAddCustomer: () => {
        closeSidebar()
        setShowAddCustomer(true)
      },
      showAddStock: () => {
        closeSidebar()
        setShowAddStock(true)
      },
      createOutwardChallan: () => {
        closeSidebar()
        setCreateOutwardChallan(true)
      },
      createInwardChallan: () => {
        closeSidebar()
        setCreateInwardChallan(true)
      },
      receiveLost: () => {
        closeSidebar()
        setReceiveLost(true)
      },
      showAddPayment: () => {
        closeSidebar()
        setShowAddPayment(true)
      },
      showOtherCharge: () => {
        closeSidebar()
        setShowOtherCharge(true)
      },
      showCreateMonthlyBill: () => {
        closeSidebar()
        setShowCreateMonthlyBill(true)
      },
      showCreateSaleInvoice: () => {
        closeSidebar()
        setShowCreateSaleInvoice(true)
      },
      siteTransfer: () => {
        closeSidebar()
        setSiteTransfer(true)
      },
      showReceiveExcess: () => {
        closeSidebar()
        setShowReceiveExcess(true)
      },
      handleLogout: handleLogout,
    }
    setActions(commandPaletteActions)
  }, [closeSidebar, setActions, handleLogout])

  return (
    <>
      <Backdrop open={logoutLoading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MenuWrapper>
        {/* Search Bar */}
        <Box sx={{ pl: 1, pr: 0.5, pt: 1, pb: 0.5 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search menu..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchTwoToneIcon />
                </InputAdornment>
              ),
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearchQuery('')}
                    edge="end"
                  >
                    <ClearTwoToneIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {hasVisibleItems(['Demo Videos', 'Tutorials']) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              LEARNING
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('Demo Videos') && (
                <ListItem component="div">
                  <Button
                    component={RouterLink}
                    to="/video-tutorials"
                    onClick={() => {
                      trackTutorialEvent(EVENTS.tutorial.sidebarMenuClicked.eventName, {
                        ...EVENTS.tutorial.sidebarMenuClicked.eventParams,
                      })
                      closeSidebar()
                    }}
                    startIcon={<PlayCircleOutlineIcon />}
                    aria-label="Demo Videos"
                  >
                    Demo Videos
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Tutorials') && (
                <ListItem component="div">
                  <Button
                    component={RouterLink}
                    to="/tutorials"
                    onClick={() => {
                      trackTutorialEvent(EVENTS.tutorial.sidebarMenuClicked.eventName, {
                        ...EVENTS.tutorial.sidebarMenuClicked.eventParams,
                      })
                      closeSidebar()
                    }}
                    startIcon={<MenuBookIcon />}
                    aria-label="Tutorials"
                  >
                    Tutorials
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}

        {/* Sites & Parties */}
        {hasVisibleItems(['Sites', 'Parties', 'Quotations', 'Agreements']) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              SITES & PARTIES
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('Sites') && (
                <ListItem component="div">
                  <Button
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.currentAccountLink()}
                    startIcon={<ViewListIcon />}
                    aria-label="Sites"
                    data-cy="sidebar_menu_sites"
                  >
                    Sites (Alt+F2)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Parties') && (
                <ListItem component="div">
                  <Button
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.customerLink()}
                    startIcon={<PeopleIcon />}
                    aria-label="Parties"
                  >
                    Parties (Alt+F3)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Quotations') && (
                <ListItem component="div">
                  <Button
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.quotationsLink()}
                    startIcon={<ReceiptLongIcon />}
                    aria-label="Quotations"
                  >
                    Quotations
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Agreements') && (
                <ListItem component="div">
                  <Button
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.agreementsLink()}
                    startIcon={<ReceiptLongIcon />}
                    aria-label="Agreements"
                  >
                    Agreements
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}

        {/* Core Actions */}
        {hasVisibleItems(['New Quotation', 'Add Site', 'Add Party', 'Issue Items', 'Receive Items', 'Lost/Damaged Items', 'Receive Payment', 'Add Other Charges', 'Create Invoice']) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              CORE ACTIONS
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('New Quotation') && (
                <ListItem component="div">
                  <Button
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.newQuotationLink()}
                    startIcon={<AddBoxIcon />}
                    aria-label="New Quotation"
                  >
                    New Quotation
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Add Site') && (
                <ListItem component="div">
                  <Button
                    onClick={() => {
                      closeSidebar()
                      setOpenNewSite(true)
                    }}
                    startIcon={<DomainAddIcon />}
                    aria-label="Add Site"
                  >
                    Add Site (F2)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Add Party') && (
                <ListItem component="div">
                  <Button
                    onClick={() => {
                      closeSidebar()
                      setShowAddCustomer(true)
                    }}
                    startIcon={<PersonAddIcon />}
                    aria-label="Add Party"
                  >
                    Add Party (F3)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Issue Items') && (
                <ListItem component="div">
                  <Button
                    onClick={() => {
                      closeSidebar()
                      setCreateOutwardChallan(true)
                    }}
                    startIcon={<PostAddIcon />}
                    aria-label="Issue Items"
                    data-cy="sidebar_menu_issue_items"
                  >
                    Issue Items (F4)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Receive Items') && (
                <ListItem component="div">
                  <Button
                    onClick={() => {
                      closeSidebar()
                      setCreateInwardChallan(true)
                    }}
                    startIcon={<InventoryIcon />}
                    aria-label="Receive Items"
                    data-cy="sidebar_menu_receive_items"
                  >
                    Receive Items (F5)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Receive Excess Oty') && (
                <ListItem component="div">
                  <Button
                    onClick={() => {
                      closeSidebar()
                      setShowReceiveExcess(true)
                    }}
                    startIcon={<InventoryIcon />}
                    aria-label="Receive Excess Oty"
                  >
                    Receive Excess Oty
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Lost/Damaged Items') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    onClick={() => {
                      closeSidebar()
                      setReceiveLost(true)
                    }}
                    startIcon={<BrokenImageIcon />}
                    aria-label="Lost/Damaged Items"
                  >
                    Lost/Damaged Items (F6)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Receive Payment') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    onClick={() => {
                      closeSidebar()
                      setShowAddPayment(true)
                    }}
                    startIcon={<PaymentIcon />}
                    aria-label="Receive Payment"
                  >
                    Receive Payment (F8)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Add Other Charges') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    onClick={() => {
                      closeSidebar()
                      setShowOtherCharge(true)
                    }}
                    startIcon={<CurrencyRupeeIcon />}
                    aria-label="Add Other Charges"
                    data-cy="sidebar_menu_add_other_charges"
                  >
                    Add Other Charges (F9)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Create Invoice') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    onClick={() => {
                      closeSidebar()
                      setShowCreateMonthlyBill(true)
                    }}
                    startIcon={<DescriptionIcon />}
                    aria-label="Create Invoice"
                  >
                    Create Invoice (F10)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Create Bulk Invoices') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.recentBillsLink()}
                    startIcon={<ListAltIcon />}
                    aria-label="Create Bulk Invoices"
                  >
                    Create Bulk Invoices
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Site To Site Transfer') && (
                <ListItem component="div">
                  <Button
                    onClick={() => {
                      closeSidebar()
                      setSiteTransfer(true)
                    }}
                    startIcon={<MoveDownIcon/>}
                    aria-label="Site To Site Transfer"
                  >
                    Site To Site Transfer
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}

      
        {/* Inventory Management */}
        {hasVisibleItems([
          'Vendors',
          'Add Stock',
          'Godown Stock',
          'Stock Transactions',
          'Party Wise Pending Items',
        ]) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              INVENTORY MANAGEMENT
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('Vendors') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      saveScrollBeforeNav()
                      closeSidebar()
                    }}
                    to={ApplicationLinks.vendorsLink()}
                    startIcon={<PeopleIcon />}
                    aria-label="Vendors"
                  >
                    Vendors
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Add Stock') && (
                <ListItem component="div">
                  <Button
                    onClick={() => {
                      closeSidebar()
                      setShowAddStock(true)
                    }}
                    startIcon={<AddBoxIcon />}
                    aria-label="Add Stock"
                  >
                    Add Stock
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Stock Transactions') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      saveScrollBeforeNav()
                      closeSidebar()
                    }}
                    to={ApplicationLinks.stockTransactionsLink()}
                    startIcon={<ReceiptIcon />}
                    aria-label="Stock Transactions"
                  >
                    Stock Transactions
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Godown Stock') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      saveScrollBeforeNav()
                      closeSidebar()
                    }}
                    to={ApplicationLinks.stockItemCategoryLink()}
                    startIcon={<CategoryTwoToneIcon />}
                    aria-label="Godown Stock"
                  >
                    Godown Stock (Alt+K)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Party Wise Pending Items') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      saveScrollBeforeNav()
                      closeSidebar()
                    }}
                    to={ApplicationLinks.sitesStockSummaryLink()}
                    startIcon={<AssessmentIcon />}
                    aria-label="Party Wise Pending Items"
                  >
                    Party Wise Pending Items
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}

        {/* Sale */}
        {hasVisibleItems(['Create Sale Invoice', 'Sale Invoices']) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              SALE
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('Create Sale Invoice') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    onClick={() => {
                      closeSidebar()
                      setShowCreateSaleInvoice(true)
                    }}
                    startIcon={<DescriptionIcon />}
                    aria-label="Create Sale Invoice"
                  >
                    Create Sale Invoice
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Sale Invoices') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.saleInvoicesLink()}
                    startIcon={<ReceiptIcon />}
                    aria-label="Sale Invoices"
                  >
                    Sale Invoices
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}

        {/* Important Lists */}
        {hasVisibleItems(['Daily Register', 'Party Wise Pending Items', 'Delivery Challan Register', 'Receiving Challan Register', 'Invoice Register', 'Party-Wise Ledger', 'Month-Wise Billing', 'Month-Wise Bills/Payment', 'Estimated Rent Chart']) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              REPORTS
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('Daily Register') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.slipsByDateLink('DATE')}
                    startIcon={<CalendarMonthIcon />}
                    aria-label="Daily Register"
                  >
                    Daily Register (Alt+D)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Delivery Challan Register') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.allChallansLink('OUT')}
                    startIcon={<LogoutTwoTone />}
                    aria-label="Delivery Challan Register"
                  >
                    Delivery Challan Register
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Receiving Challan Register') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.allChallansLink('IN')}
                    startIcon={<LoginTwoTone />}
                    aria-label="Receiving Challan Register"
                  >
                    Receiving Challan Register
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Invoice Register') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.allBillsLink()}
                    startIcon={<ReceiptIcon />}
                    aria-label="Invoice Register"
                  >
                    Invoice Register
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Payment Register') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.paymentHistoryLink()}
                    startIcon={<PaymentIcon />}
                    aria-label="Payment Register"
                  >
                    Payment Register
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Party-Wise Ledger') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.ledgerSummaryLink()}
                    startIcon={<AccountBalanceIcon />}
                    aria-label="Party-Wise Ledger"
                  >
                    Party-Wise Ledger
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Party Wise Pending Items') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      saveScrollBeforeNav()
                      closeSidebar()
                    }}
                    to={ApplicationLinks.sitesStockSummaryLink()}
                    startIcon={<AssessmentIcon />}
                    aria-label="Party Wise Pending Items"
                  >
                    Party Wise Pending Items
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Month-Wise Billing') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.allSitesLedgerLink()}
                    startIcon={<AssessmentIcon />}
                    aria-label="Month-Wise Billing"
                  >
                    Month-Wise Billing
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Month-Wise Bills/Payment') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.billsPaymentChartLink()}
                    startIcon={<AssessmentIcon />}
                    aria-label="Month-Wise Bills/Payment"
                  >
                    Month-Wise Bills/Payment
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Estimated Rent Chart') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.billingChartLink()}
                    startIcon={<AssessmentIcon />}
                    aria-label="Estimated Rent Chart"
                  >
                    Estimated Rent Chart
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}

        {/* Analytics & Reports */}
        {hasVisibleItems(['GSTR1 Report', 'GSTR 3B Report']) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
             GST FILING
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('GSTR1 Report') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.gstr1PreviewLink()}
                    startIcon={<AssessmentIcon />}
                    aria-label="GSTR1 Report"
                  >
                    GSTR1 Report
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('GSTR 3B Report') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.gstr3bLink()}
                    startIcon={<SummarizeIcon />}
                    aria-label="GSTR 3B Report"
                  >
                    GSTR 3B Report
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}

        {/* Settings & Administration */}
        {hasVisibleItems([
          'Business Profile',
          'Invoice Settings',
          'Import Data',
          'Software Settings',
          'Users Management',
          'Switch Account',
        ]) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              SETTINGS & ADMINISTRATION
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('Business Profile') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.profileDetailLink()}
                    startIcon={<BusinessIcon />}
                    aria-label="Business Profile"
                  >
                    Business Profile (Alt+P)
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Invoice Settings') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.invoiceTnCLink()}
                    startIcon={<StoreIcon />}
                    aria-label="Invoice Settings"
                  >
                    Invoice & Challan Settings
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Import Data') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={() => {
                      saveScrollBeforeNav()
                      closeSidebar()
                    }}
                    to={ApplicationLinks.importDataLink()}
                    startIcon={<FileUploadIcon />}
                    aria-label="Import Data"
                  >
                    Import Data
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Software Settings') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.profileSettingsLink()}
                    startIcon={<SettingsIcon sx={{color:'#9400D3'}}/>}
                  >
                    <Typography sx={{color:'#9400D3'}}>Software Settings (Alt+S)</Typography>
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Users Management') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.staffLink()}
                    startIcon={<GroupAddIcon />}
                    aria-label="Users Management"
                  >
                    Users Management
                  </Button>
                </ListItem>
              )}
              {data?.myStores?.length > 0 && shouldShowMenuItem('Switch Account') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.storeChangeLink()}
                    startIcon={<StoreIcon />}
                    aria-label="Switch Account"
                  >
                    Switch Account
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}

        {/* System & Support */}
        {hasVisibleItems(['Software Usage Bills', 'Purchase/Activate Plan', 'Manage Backups', 'Contact Support', 'Logout']) && (
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              SYSTEM & SUPPORT
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {shouldShowMenuItem('Software Usage Bills') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.pendingBillsLink()}
                    startIcon={<ReceiptIcon />}
                    aria-label="Software Usage Bills"
                  >
                    Software Usage Bills
                  </Button>
                </ListItem>
              )}

              {process.env.OFFLINE && (
                <>
                  {shouldShowMenuItem('Purchase/Activate Plan') && (
                    <ListItem component="div">
                      <Button
                        disableRipple
                        component={RouterLink}
                        onClick={closeSidebar}
                        to={ApplicationLinks.subscriptionPlansLink()}
                        startIcon={<ReceiptIcon />}
                        aria-label="Purchase/Activate Plan"
                      >
                        Purchase/Activate Plan
                      </Button>
                    </ListItem>
                  )}
                  {shouldShowMenuItem('Manage Backups') && (
                    <ListItem component="div">
                      <Button
                        disableRipple
                        component={RouterLink}
                        onClick={closeSidebar}
                        to={ApplicationLinks.restoreBackup()}
                        startIcon={<RestoreIcon />}
                        aria-label="Manage Backups"
                      >
                        Manage Backups
                      </Button>
                    </ListItem>
                  )}
                </>
              )}
              {shouldShowMenuItem('Contact Support') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={ApplicationLinks.contactUsLink()}
                    startIcon={<ContactSupportIcon />}
                    aria-label="Contact Support"
                  >
                    Contact Support
                  </Button>
                </ListItem>
              )}
              {shouldShowMenuItem('Logout') && (
                <ListItem component="div">
                  <Button
                    disableRipple
                    onClick={handleLogout}
                    disabled={logoutLoading}
                    startIcon={logoutLoading ? <CircularProgress size={20} color="inherit" /> : <LogoutIcon />}
                    aria-label="Logout"
                  >
                    Logout
                  </Button>
                </ListItem>
              )}
            </List>
          </SubMenuWrapper>
        </List>
        )}
      </MenuWrapper>
      {openNewSite && (
        <AddAccountItem
         customer={newCustomer}
          onClose={(newAccount?: Bill, result?: boolean) => {
            setNewCustomer(null)
            setOpenNewSite(false)
            setNewAccount(newAccount)
            if (newAccount) {
              setCreateOutwardChallan(true)
            } else if(result) {
              setShowAddCustomer(true)
            }
          }}
        />)}
        
      {createOutwardChallan && (
        <IssueMoreItem
          bill_id={newAccount?.id}
          customer_id={newAccount?.customer.id}
          onClose={() => {
            setNewAccount(null)
            setCreateOutwardChallan(false)
          }
          }
          billInfo={newAccount}
          billType={newAccount?.billType}
        />
      )}

      {siteTransfer && (
        <IssueMoreItem
          bill_id={newAccount?.id}
          customer_id={newAccount?.customer.id}
          onClose={() => {
            setNewAccount(null)
            setCreateOutwardChallan(false)
            setSiteTransfer(false)
          }
          }
          siteTransfer = {true}
          billInfo={newAccount}
          billType={newAccount?.billType}
        />
      )}

      {createInwardChallan && (
        <SubmitItem
          bill_id={null}
          customer_id={null}
          onClose={(success?: boolean, site?: SiteDto) => {
            setCreateInwardChallan(false)
            if (site) {
              navigate(`/slips/view-slips/${site.id}/${site.customerId}?tab_index=0`)
            }
          }}
          billType={null}
          bill={newAccount}
        />
      )}

      {showReceiveExcess && (
        <IssueMoreItem
          bill_id={0}
          customer_id={0}
          billType={''}
          onClose={() => setShowReceiveExcess(false)}
          mode="EXCESS"
        />
      )}

      {showReceiveLost && (
        <SubmitItem
          bill_id={null}
          customer_id={null}
          onClose={(success?: boolean, site?: SiteDto) => {
            setReceiveLost(false)
            if (site) {
              navigate(`/slips/view-slips/${site.id}/${site.customerId}?tab_index=0`)
            }
          }}
          submission_type={'LOST'}
          billType={null}
          bill={newAccount}
        />
      )}
      {showCreateMonthlyBill && (
        <CreateMonthlyBill
          onClose={(site?: SiteDto) => {
            setShowCreateMonthlyBill(false)
            if (site) {
              navigate(`/slips/view-slips/${site.id}/${site.customerId}?tab_index=6`)
            }
          }}
          account={null}
        />
      )}

      {showCreateSaleInvoice && (
        <CreateSaleInvoiceDialog
          onClose={() => {
            setShowCreateSaleInvoice(false)
          }}
        />
      )}

      {showAddPayment && (
        <AddEditPaymentItem
          onClose={() => {
            setShowAddPayment(false)
          }}
          onSubmitSuccess={(site?: SiteDto) => {
            setShowAddPayment(false)
            if (site) {
              navigate(`/slips/view-slips/${site.id}/${site.customerId}?tab_index=4`)
            }
          }}
        />
      )}

      {showOtherCharge && (
        <OtherCharges
          bill_id={null}
          customer_id={null}
          onClose={(site?: SiteDto) => {
            setShowOtherCharge(false)
            if (site) {
              navigate(`/slips/view-slips/${site.id}/${site.customerId}?tab_index=0`)
            }
          }}
          title={'Add Other Charges'}
          isQuotation={false}
        />
      )}

       {showAddCustomer && (
        <AddCustomer
          onClose={(customer) => {
            setShowAddCustomer(false)
            setNewCustomer(customer)
            setOpenNewSite(customer != null && customer != undefined)
          }}
        />
      )}

      {showAddStock && (
        <AddStockDialog
          onClose={() => {
            setShowAddStock(false)
            setNewVendorForAddStock(null)
          }}
          onSuccess={() => {
            setShowAddStock(false)
            setNewVendorForAddStock(null)
            navigate(ApplicationLinks.stockTransactionsLink())
          }}
          initialVendor={newVendorForAddStock}
          onRequestAddVendor={() => {
            setShowAddStock(false)
            setShowAddVendorForStock(true)
          }}
        />
      )}
      {showAddVendorForStock && (
        <AddVendor
          onClose={(vendor) => {
            setShowAddVendorForStock(false)
            if (vendor) {
              setNewVendorForAddStock(vendor)
              setShowAddStock(true)
            }
          }}
        />
      )}
    </>
  )
}

export default SidebarMenu
